import axiosInstance from "../../utils/axios"

export const getCpCheckList = async () => {
    let res = await axiosInstance.get(`/tracker/get_tracker_types`,)
    return res
}

export const getCheckLists = async (value) => {
    let res = await axiosInstance.get(`/checklist/get_checklist?type=${value}`,)
    return res
}

export async function getallactivities() {
    let res = await axiosInstance.get(`/projects/fetch/activities/group`)
    return res
}

export const getbomlists = async () => {
    let res = await axiosInstance.get(`projects/activitymilestone`)
    return res
}


export async function getTypeDatas() {
    let responseData = await axiosInstance.get(`projects/tracker_type_map_type`)
    return responseData
}

export async function getCheckListData() {
    let responseData = await axiosInstance.get(`/projects/fetch_checklist_mappings`)
    return responseData
}

export async function getSvgData(id) {
    let responseData = await axiosInstance.get(`/tracker_row/bulk/all?tracker_type_id=${id}`)
    return responseData
}
